var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};
var site = site || {};

(function ($) {
  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId, hasDramming) {
    // don't execute only on init for dramming product
    if (hasDramming === 'noshade') {
      return;
    }
    if (typeof skuBaseId === 'undefined') {
      skuBaseId = prodcat.ui.getSkuIdByProduct($(this));
    }
    var $product = $(this);
    var $shadesGrid = $product.find('.js-product-starter-shades-grid');
    var $selectedShade = $shadesGrid.find(
      '.js-product-starter-shades-grid-item[data-sku-base-id="' + skuBaseId + '"]'
    );
    var $productImageKit = $product.find('.js-product-starter-items-section-image');
    var $shadeThumbKit = $product.find('.js-product-starter-items-section-image-thumb');
    var skuData = prodcat.data.getSku(skuBaseId);

    if ($shadesGrid.length < 1) {
      return null;
    }
    $product.attr('data-sku-base-id', skuBaseId);
    var $shadeGridItem = $('.js-product-starter-shades-grid-item', $product);

    if (hasDramming) {
      $('.js-product-starter-shades-grid-item.secondactive', $product).removeClass(
        'active secondactive'
      );
      $selectedShade.addClass('active secondactive');
    } else {
      $shadeGridItem.not('.secondactive').removeClass('active');
      $shadeThumbKit.removeClass('hidden');
      $shadeThumbKit.attr('data-src', skuData.IMAGE_LARGE_COMBINED[1]);
      $shadeThumbKit.attr('src', skuData.IMAGE_LARGE_COMBINED[1]);
      $productImageKit.addClass('hidden');
      $selectedShade.addClass('active');
    }
  });

  $(document).on(
    'product.skuSelectKit',
    '.js-starter-kit-v1',
    function (e, skuBaseId, hasDramming, $shadesGrid) {
      if (typeof skuBaseId === 'undefined') {
        skuBaseId = prodcat.ui.getSkuIdByProduct($(this));
      }
      var $product = $(this);
      var $starterItemsShaded = $(
        '.js-product-starter-item:not(.js-product-starter-non-shaded-item)',
        $product
      );
      var $starterItem = $shadesGrid.closest('.js-product-starter-item');
      var $productImageKit = $starterItem.find('.js-product-starter-items-section-image');
      var $shadeThumbKit = $starterItem.find('.js-product-starter-items-section-image-thumb');
      var skuData = prodcat.data.getSku(skuBaseId);
      var $selectedShade = $shadesGrid.find(
        '.js-product-starter-shades-grid-item[data-sku-base-id="' + skuBaseId + '"]'
      );
      var $shadeGridItem = $('.js-product-starter-shades-grid-item', $shadesGrid);
      var $addBtn = $('.js-kit-add-to-cart', $product);
      var selected_skus = [];
      var skusNoShoppable = [];

      if ($shadesGrid.length < 1) {
        return null;
      }
      $product.attr('data-sku-base-id', skuBaseId);
      if (hasDramming) {
        $('.js-product-starter-shades-grid-item.secondactive', $product).removeClass(
          'active secondactive'
        );
        $selectedShade.addClass('active secondactive');
      } else {
        $shadeGridItem.not('.secondactive').removeClass('active');
        $shadeThumbKit.removeClass('hidden');
        $shadeThumbKit.attr('data-src', skuData.IMAGE_LARGE_COMBINED[1]);
        $shadeThumbKit.attr('src', skuData.IMAGE_LARGE_COMBINED[1]);
        $productImageKit.addClass('hidden');
        $selectedShade.addClass('active');
      }

      $starterItemsShaded.each(function () {
        var $item = $(this);
        var $selectedShade = $item.find('.js-product-starter-shades-grid-item.active').first();

        if ($selectedShade.length) {
          var skuBaseId = $selectedShade.data('sku-base-id');

          selected_skus.push(skuBaseId);
        }
      });

      if (selected_skus.length === $starterItemsShaded.length) {
        skusNoShoppable = $.grep(selected_skus, function (skuId) {
          var skuDataL2 = prodcat.data.getSku(skuId);

          return skuDataL2.INVENTORY_STATUS !== 1;
        });

        if (skusNoShoppable.length <= 0) {
          $addBtn.removeClass('button--disabled').data('disabled', false);
          $('.js-buy-now-btn').removeClass('button--disabled').data('disabled', false);
        } else {
          $addBtn.addClass('button--disabled').data('disabled', true);
          $('.js-buy-now-btn').addClass('button--disabled').data('disabled', true);
        }
      }

      var skus_string = selected_skus.join(',');

      $addBtn.data('kit-skus', skus_string);
      $('.js-buy-now-btn').data('kit-skus', skus_string);
    }
  );

  $(document).on('inv_status_display:updated', '.js-product', function () {
    var $product = $(this);
    var $shadeGrid = $product.find('.js-product-starter-shades-grid');
    var $items = $shadeGrid.find('.js-product-starter-shades-grid-item');

    $items.each(function () {
      var $this = $(this);
      var enableReorder = $this.closest($shadeGrid).find($items).length > 1;
      var skuBaseId = $this.data('sku-base-id');
      var currentInvStatus = $this.data('inventoryStatus');
      var skuDataL2 = prodcat.data.getSku(skuBaseId);
      var invStatus;

      if (!skuDataL2) {
        if (currentInvStatus !== 1 && enableReorder) {
          $this.closest($shadeGrid).append($this);
        }

        return;
      }

      invStatus = skuDataL2.INVENTORY_STATUS;
      if (currentInvStatus === invStatus && invStatus !== 1 && enableReorder) {
        $this.closest($shadeGrid).append($this);
      }
      // Update Shade Inventory Status
      if (parseInt(currentInvStatus) !== parseInt(invStatus)) {
        $this.removeClass('shade-inv-status--' + currentInvStatus);
        $this.addClass('shade-inv-status--' + invStatus);
        $this.attr('data-inventory-status', invStatus).data('inventoryStatus', invStatus);
        if (invStatus !== 1 && enableReorder) {
          $this.closest($shadeGrid).append($this);
        }
      }
    });
  });

  Drupal.behaviors.productStarterItemsV1 = {
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.$addBtn = $('.js-add-to-cart', '.js-product-dramming');
      if ($('.js-second-shade-select-option').length) {
        self.drammingPage = true;
        self.$addBtn.addClass('button--disabled');
        self.$addBtn.data('disabled', true);
      }

      var $templates = $('.product-starter-shades-v1', context);

      $templates.each(function () {
        var $template = $(this);

        self.initShadesCarousel($template);
        $(window).on(
          'resize',
          _.debounce(function () {
            self.initShadesCarousel($template);
          }, 100)
        );
        self.setEvents($template);
      });

      $(document).on('product:quickshopV2', function () {
        var $template;

        $template = $('.product-starter-shades-v1', $(this));
        self.setEvents($template);
      });
    },

    setEvents: function ($template) {
      var self = this;
      var $product = $template.closest('.js-product');
      var $shadesGrid = $('.js-product-starter-shades-grid', $product);
      var $shadesGridItem = $('.js-product-starter-shades-grid-item', $product);
      var $shadesTabs = $('.js-product-full-shade--filter', $product);

      $shadesGridItem.once().on('click', function (event) {
        event.preventDefault();
        var $this = $(this);
        var skuBaseId = $this.data('sku-base-id');
        var $shadesGridParent = $this.closest('.js-product-starter-shades-grid');

        // Restrict the second click on the same shade
        if ($this.hasClass('active')) {
          return;
        }
        $product.trigger('product.skuSelectKit', [skuBaseId, self.toggleShade, $shadesGridParent]);
        if (self.drammingPage) {
          self.toggleShade = !self.toggleShade;
        }
      });

      // @todo check ADA - we are not using href for shade
      $shadesGridItem.once().on('keydown', function (e) {
        if (site.getKeycode(e) === 13) {
          $(this).trigger('click');
        }
      });

      $('.js-product-full-shade--filter')
        .once()
        .on('click tab', function (event) {
          event.preventDefault();
          var $tab = $(this);
          var colorFamily = $tab.data('filter');

          $product.trigger('product.showColorFamily', [colorFamily]);
        });

      $(document).on('product.showColorFamily', '.js-product', function (e, colorFamily) {
        var defaultFamily = 'all';
        var selectedColorFamily;
        var $selectedShade = $shadesGrid
          .find('.js-product-starter-shades-grid-item.active')
          .first();
        var skuBaseId = $selectedShade.data('sku-base-id');

        $shadesTabs.removeClass('active');
        $shadesTabs.each(function () {
          selectedColorFamily = $(this).data('filter');
          if (
            typeof selectedColorFamily !== typeof undefined &&
            selectedColorFamily === colorFamily
          ) {
            $(this).addClass('active');
          }
        });
        $shadesGridItem.removeClass('hidden');

        if (colorFamily !== defaultFamily) {
          $shadesGridItem.each(function () {
            var $shade = $(this);
            var shadeFamily = $shade.data('shade-family');

            if (!!shadeFamily) {
              shadeFamily = shadeFamily.replace(/\s+/g, '').toLowerCase().split(',');
              if (shadeFamily.indexOf(colorFamily.toLowerCase()) === -1) {
                $shade.addClass('hidden');
              }
            }
          });
        }
        self.loadSelectedShade(skuBaseId, colorFamily, $product, $shadesTabs);
        Drupal.behaviors.productFullShadesV1.initShadesCarousel($template);
      });

      $(document).trigger('product.colorFamilyLoaded');
    },

    toggleShade: false,
    drammingPage: false,
    initShadesCarousel: function ($container) {
      var $shadesContent = $('.js-product-starter-shades-grid-content', $container);
      var $shadesItem = $('.js-product-starter-shades-grid-item:not(.hidden)', $container);
      var $shadesGrid = $('.js-product-starter-shades-grid', $container);
      var $prevArrow = $('.js-arrow-prev', $container);
      var $nextArrow = $('.js-arrow-next', $container);

      $shadesGrid.width('');
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPportraitUp = parseInt(Unison.fetch.all()['portrait'], 10);
      var isDesktop = currentBpWidth >= bPportraitUp;

      if (isDesktop) {
        return;
      }

      // Hide next and prev arrow if there are less than 7 shades
      if ($shadesItem.length < 7) {
        $prevArrow.addClass('hidden');
        $nextArrow.addClass('hidden');
      } else {
        $prevArrow.removeClass('hidden');
        $prevArrow.addClass('inactive');
        $nextArrow.removeClass('hidden');
        $nextArrow.removeClass('inactive');
      }

      var shadesItemWidth = $shadesItem.first().outerWidth(true);
      var shadesgridWidth = $shadesItem.length * shadesItemWidth;

      if ($shadesItem.length >= 6) {
        $shadesGrid.width(shadesgridWidth);
      }

      $('.js-arrow-prev', $container)
        .once()
        .on('click tab', function () {
          var $self = $(this);
          var carouselWidth = $shadesContent.outerWidth(false);
          var position = $shadesGrid.position().left;

          if ($self.hasClass('inactive') || $self.hasClass('animating')) {
            return;
          }
          $self.addClass('animating');
          $shadesContent.animate(
            {
              scrollLeft: -position - carouselWidth
            },
            500,
            function () {
              $self.removeClass('animating');
            }
          );
        });
      $('.js-arrow-next', $container)
        .once()
        .on('click tab', function () {
          var $self = $(this);
          var carouselWidth = $shadesContent.outerWidth(false);
          var position = $shadesGrid.position().left;

          if ($self.hasClass('inactive') || $self.hasClass('animating')) {
            return;
          }
          $self.addClass('animating');
          $shadesContent.animate(
            {
              scrollLeft: -Math.floor(position) + carouselWidth
            },
            500,
            function () {
              $self.removeClass('animating');
            }
          );
        });
      $shadesContent.once().on(
        'scroll',
        _.debounce(function () {
          var $self = $(this);
          var position = $shadesGrid.position().left;
          var carouselWidth = $self.outerWidth(false);
          var containerWidth = $shadesGrid.outerWidth(false);

          if (position === 0) {
            $('.js-arrow-prev', $container).addClass('inactive');
          } else if (Math.floor(position) <= carouselWidth - containerWidth) {
            $('.js-arrow-next', $container).addClass('inactive');
          } else {
            $('.js-arrow-next', $container).removeClass('inactive');
            $('.js-arrow-prev', $container).removeClass('inactive');
          }
        }, 10)
      );
    },

    loadSelectedShade: function (skuBaseId, colorFamily, $product, $shadesTabs) {
      var skuData = prodcat.data.getSku(skuBaseId);
      var shadeName = _.result(skuData, 'SHADENAME');
      var shadeRouteName = prodcat.ui.generateShadePath(skuBaseId);

      if (skuBaseId && $product.hasClass('js-product-full-v2')) {
        history.replaceState({}, shadeName, shadeRouteName);

        return;
      }

      if (colorFamily !== $shadesTabs.first().text()) {
        if ($product.hasClass('product-full')) {
          history.replaceState({}, colorFamily, '#/family/' + colorFamily);
        }
      } else {
        if ($product.hasClass('product-full')) {
          history.replaceState({}, colorFamily, '#');
        }
      }

      return;
    },
    attached: false
  };
})(jQuery);
